import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { History, Printer, Pencil, Trash2 } from "lucide-react";

export function HistoryDialog({ open, onClose, history, onDelete, onClear, onReprint, onLoad }) {
  const fmt = (iso) =>
    new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="max-w-lg" data-testid="history-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            <History size={20} className="text-sky-600" /> Riwayat Resi
          </DialogTitle>
          <DialogDescription>Cetak ulang atau muat kembali resi yang pernah dibuat.</DialogDescription>
        </DialogHeader>

        {history.length === 0 ? (
          <div className="text-center text-sm text-slate-400 py-10">
            Belum ada resi. Cetak atau ekspor label untuk mulai menyimpan riwayat.
          </div>
        ) : (
          <>
            <div className="flex justify-end">
              <Button variant="ghost" size="sm" className="text-red-500 text-xs" data-testid="btn-clear-history"
                onClick={() => onClear?.()}>
                <Trash2 size={14} className="mr-1" /> Hapus semua
              </Button>
            </div>
            <div className="max-h-[50vh] overflow-auto space-y-2 pr-1">
              {history.map((h, i) => (
                <div key={h.id} data-testid={`history-item-${i}`}
                  className="flex items-center gap-2 rounded-lg border border-slate-200 p-3">
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-sm truncate text-slate-900">
                      {h.label.recipient_name || "(tanpa nama)"}
                    </div>
                    <div className="text-xs text-slate-500 truncate">
                      {(h.label.courier || "-")} • {(h.label.phone || "-")}
                    </div>
                    <div className="text-[11px] text-slate-400">{fmt(h.at)}</div>
                  </div>
                  <Button size="icon" variant="outline" title="Cetak ulang" data-testid={`history-reprint-${i}`}
                    onClick={() => onReprint(h.label)}>
                    <Printer size={15} />
                  </Button>
                  <Button size="icon" variant="ghost" title="Muat ke editor" data-testid={`history-load-${i}`}
                    onClick={() => onLoad(h.label)}>
                    <Pencil size={15} />
                  </Button>
                  <Button size="icon" variant="ghost" className="text-red-500" title="Hapus"
                    onClick={() => onDelete?.(h.id)}>
                    <Trash2 size={15} />
                  </Button>
                </div>
              ))}
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
